// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__ooHdM","face":"Avatar_face__jKrDb","role":"Avatar_role__FXYuP"};